import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import {
  FiChevronLeft,
  FiChevronRight,
  FiShield,
  FiMail,
  FiPhone,
  FiMapPin,
  FiX
} from 'react-icons/fi'
import AdUnit from '../common/AdUnit'

export default function AuthLayout({ children }) {
  const [advertisements, setAdvertisements] = useState([])
  const [currentAdIndex, setCurrentAdIndex] = useState(0)
  const [loading, setLoading] = useState(true)
  const [showAboutModal, setShowAboutModal] = useState(false)
  const [showFeaturesModal, setShowFeaturesModal] = useState(false)
  const [showContactModal, setShowContactModal] = useState(false)
    const [showPrivacyPolicyModal, setShowPrivacyPolicyModal] = useState(false) // 🔧 Added


  useEffect(() => {
    fetchAdvertisements()
  }, [])

  useEffect(() => {
    if (advertisements.length > 1) {
      const interval = setInterval(() => {
        setCurrentAdIndex((prev) => (prev + 1) % advertisements.length)
      }, 5000)
      return () => clearInterval(interval)
    }
  }, [advertisements.length])

  const fetchAdvertisements = async () => {
    try {
      const response = await axios.get('/advertisements/active')
      setAdvertisements(response.data.advertisements || [])
    } catch (error) {
      console.error('Error fetching advertisements:', error)
      setAdvertisements([])
    } finally {
      setLoading(false)
    }
  }

  const nextAd = () => {
    setCurrentAdIndex((prev) => (prev + 1) % advertisements.length)
  }

  const prevAd = () => {
    setCurrentAdIndex((prev) => (prev - 1 + advertisements.length) % advertisements.length)
  }

  const Modal = ({ title, content, onClose }) => (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-white max-w-2xl w-full rounded-lg shadow-lg overflow-y-auto max-h-[90vh] relative p-6">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700">
          <FiX className="w-5 h-5" />
        </button>
        <h2 className="text-2xl font-bold mb-4">{title}</h2>
        <div className="text-gray-700 whitespace-pre-wrap text-sm leading-relaxed">{content}</div>
      </div>
    </div>
  )

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-blue-50 to-indigo-100">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <div className="flex-shrink-0 flex items-center">
                <div className="w-10 h-10 bg-gradient-to-br from-primary-600 to-primary-700 rounded-lg flex items-center justify-center mr-3">
                  <FiShield className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h1 className="text-xl font-bold text-gray-900">
                    Marketbook<span className="text-primary-600">&solution</span>
                  </h1>
                  <p className="text-xs text-gray-500">Comprehensive professional business management services</p>
                </div>
              </div>
            </div>
            <nav className="hidden md:flex items-center space-x-8">
              <button onClick={() => setShowFeaturesModal(true)} className="text-gray-600 hover:text-primary-600 text-sm font-medium transition-colors">Features</button>
              <button onClick={() => setShowAboutModal(true)} className="text-gray-600 hover:text-primary-600 text-sm font-medium transition-colors">About</button>
              <button onClick={() => setShowContactModal(true)} className="text-gray-600 hover:text-primary-600 text-sm font-medium transition-colors">Contact</button>
                <button onClick={() => setShowPrivacyPolicyModal(true)}  className="text-gray-600 hover:text-primary-600 text-sm font-medium transition-colors">PrivacyPolicy</button>
              {/* <Link to="/global-admin-login" className="text-gray-600 hover:text-primary-600 text-sm font-medium transition-colors">Admin Portal</Link> */}
            </nav>
            <div className="hidden lg:flex items-center space-x-4 text-sm text-gray-600">
              <div className="flex items-center">
                <FiMail className="w-4 h-4 mr-1" />
                <span>support@marketbooksolution.com</span>
              </div>
              <div className="flex items-center">
                {/* <FiPhone className="w-4 h-4 mr-1" /> */}
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Existing JSX */}
    <div className="flex min-h-[calc(100vh-64px)]">
        {/* Left Side */}
        <div className="hidden lg:flex lg:w-1/2 items-center justify-center p-12 bg-gradient-to-br from-primary-600 to-primary-800">
          <div className="max-w-md text-center text-white">
            <div className="mb-8">
              <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
                <FiShield className="w-10 h-10 text-white" />
              </div>
              <h1 className="text-4xl font-bold mb-4">
                Welcome to Marketbook<span className="text-primary-200">&solution</span>
              </h1>
              <p className="text-xl text-primary-100 mb-8">
                The complete Professional management system & Website builder 
              </p>
            </div>
            <div className="space-y-6 text-left">
              {/* Feature Items */}
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center mt-1">
                  <div className="w-2 h-2 bg-white rounded-full"></div>
                </div>
                <div>
                  <h3 className="font-semibold text-white mb-1">Professional Invoice Generation</h3>
                  <p className="text-primary-100 text-sm">Create, send, and track professional invoices and notes with ease</p>
                </div>
               </div>
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center mt-1">
                  <div className="w-2 h-2 bg-white rounded-full"></div>
                </div>
                <div>
                  <h3 className="font-semibold text-white mb-1">Website builder</h3>
                  <p className="text-primary-100 text-sm">Create stunning websites without any coding knowledge</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center mt-1">
                  <div className="w-2 h-2 bg-white rounded-full"></div>
                </div>
                <div>
                  <h3 className="font-semibold text-white mb-1">Advanced Admin Controls</h3>
                  <p className="text-primary-100 text-sm">Comprehensive management tools for power users</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center mt-1">
                  <div className="w-2 h-2 bg-white rounded-full"></div>
                </div>
                <div>
                  <h3 className="font-semibold text-white mb-1">Real-time Notifications & Escrow Support</h3>
                  <p className="text-primary-100 text-sm">Stay updated with instant alerts and ensure secure transactions through built-in escrow features.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center mt-1">
                  <div className="w-2 h-2 bg-white rounded-full"></div>
                </div>
                <div>
                  <h3 className="font-semibold text-white mb-1">24/7 Support System & Professional Services</h3>
                  <p className="text-primary-100 text-sm">Get support whenever you need it with our dedicated Support System.</p>
                </div>
              </div>
            </div>
            <div className="mt-8 pt-8 border-t border-white/20">
              <p className="text-primary-100 text-sm">Trusted by thousands of businesses worldwide</p>
            </div>
          </div>
        </div>

        {/* Right Side */}
        <div className="w-full lg:w-1/2 flex flex-col">
          {!loading && advertisements.length > 0 && (
            <div className="bg-white shadow-sm border-b border-gray-200">
              <div className="relative h-32 md:h-40 overflow-hidden">
                {advertisements.map((ad, index) => (
                  <div
                    key={ad._id}
                    className={`absolute inset-0 transition-transform duration-500 ease-in-out ${
                      index === currentAdIndex ? 'translate-x-0' : index < currentAdIndex ? '-translate-x-full' : 'translate-x-full'
                    }`}
                  >
                    <div className="flex items-center justify-center h-full px-6 bg-gradient-to-r from-gray-50 to-white">
                      {ad.mediaType === 'image' ? (
                        <img src={ad.mediaUrl} alt={ad.name} className="max-h-full max-w-[200px] object-contain rounded-lg shadow-sm"
                          onError={(e) => { e.target.style.display = 'none' }} />
                      ) : (
                        <video src={ad.mediaUrl} autoPlay muted loop className="max-h-full max-w-[200px] object-contain rounded-lg shadow-sm"
                          onError={(e) => { e.target.style.display = 'none' }} />
                      )}
                      <div className="ml-6 flex-1 max-w-md">
                        <h3 className="text-lg font-semibold text-gray-900 mb-1">{ad.name}</h3>
                        <p className="text-sm text-gray-600">{ad.description}</p>
                        <div className="mt-2">
                          <span className="inline-block px-2 py-1 bg-primary-100 text-primary-800 text-xs font-medium rounded-full">
                            Featured
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                {advertisements.length > 1 && (
                  <>
                    <button onClick={prevAd} className="absolute left-2 top-1/2 -translate-y-1/2 p-2 rounded-full bg-white/90 hover:bg-white shadow-md transition-all hover:scale-105">
                      <FiChevronLeft className="w-5 h-5 text-gray-600" />
                    </button>
                    <button onClick={nextAd} className="absolute right-2 top-1/2 -translate-y-1/2 p-2 rounded-full bg-white/90 hover:bg-white shadow-md transition-all hover:scale-105">
                      <FiChevronRight className="w-5 h-5 text-gray-600" />
                    </button>
                  </>
                )}
              </div>
              {advertisements.length > 1 && (
                <div className="flex justify-center py-3 space-x-2 bg-gray-50">
                  {advertisements.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentAdIndex(index)}
                      className={`w-2 h-2 rounded-full transition-all ${
                        index === currentAdIndex ? 'bg-primary-600 w-6' : 'bg-gray-300 hover:bg-gray-400'
                      }`}
                    />
                  ))}
                </div>
              )}
            </div>
          )}

          {/* Auth Form Container */}
          <div className="flex-1 flex items-center justify-center p-6 bg-white">
            <div className="w-full max-w-md">
              <div className="lg:hidden text-center mb-8">
                <div className="w-16 h-16 bg-gradient-to-br from-primary-600 to-primary-700 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <FiShield className="w-8 h-8 text-white" />
                </div>
                <h1 className="text-3xl font-bold text-gray-900 mb-2">
                  Marketbook<span className="text-primary-600">&solution</span>
                </h1>
                <p className="text-gray-600">Professional business management</p>
              </div>
              {children}
              <AdUnit />
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="col-span-1 md:col-span-2">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 bg-gradient-to-br from-primary-600 to-primary-700 rounded-lg flex items-center justify-center mr-3">
                  <FiShield className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-bold">
                    Marketbook<span className="text-primary-400">&solution</span>
                  </h3>
                  <p className="text-gray-400 text-sm">Professional invoicing and business management</p>
                </div>
              </div>
              <p className="text-gray-300 mb-4 max-w-md">
                Empowering businesses with professional invoicing, website creation, and powerful business management tools. Create, manage, and grow your business with our all-in-one platform.
              </p>
              <div className="space-y-2">
                <div className="flex items-center text-gray-300">
                  <FiMail className="w-4 h-4 mr-2" />
                  <span className="text-sm">support@marketbooksolution.com</span>
                </div>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li><button onClick={() => setShowFeaturesModal(true)} className="text-gray-300 hover:text-white transition-colors text-sm">Features</button></li>
                 <li><button onClick={() => setShowPrivacyPolicyModal(true)} className="text-gray-300 hover:text-white transition-colors text-sm">Privacy Policy</button></li>
                <li><button onClick={() => setShowAboutModal(true)} className="text-gray-300 hover:text-white transition-colors text-sm">About Us</button></li>
                <li><button onClick={() => setShowContactModal(true)} className="text-gray-300 hover:text-white transition-colors text-sm">Contact</button></li>
                {/* <li><Link to="/global-admin-login" className="text-gray-300 hover:text-white transition-colors text-sm">Admin Portal</Link></li> */}
              </ul>
            </div>

            <div>
              <h3 className="font-semibold mb-2 text-white">About This App</h3>
              <p className="text-gray-400 leading-relaxed">
                Marketbook Solution is an all-in-one platform to create invoices, build websites, manage products and tickets, handle secure transactions, and grow your business—plus business and employee ID creation to elevate your brand.
              </p>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">© 2025 Marketbook&solution. All rights reserved.</p>
          </div>
        </div>
      </footer>

{/* MODALS */}
{showAboutModal && (
  <Modal
    title="About Marketbook Solution App"
    onClose={() => setShowAboutModal(false)}
    content={`WHAT IS MARKETBOOK SOLUTION?

Marketbook Solution is an all-in-one business management and website building platform designed to empower entrepreneurs, freelancers, small businesses, and enterprises. Whether you're selling products, offering services, or managing operations, our app provides everything you need to succeed.

CORE CAPABILITIES

✓ PROFESSIONAL INVOICING & PAYMENTS
  Create and send professional invoices in multiple currencies
  Track payment status in real-time
  Manage transactions securely with escrow protection
  Generate financial reports and history

✓ CUSTOM WEBSITE BUILDER
  Build stunning, professional websites without coding
  Add products, services, galleries, and team sections
  Configure custom domains for professional branding
  Optimize SEO with meta titles and descriptions
  Showcase your business online instantly

✓ INVENTORY & PRODUCT MANAGEMENT
  Create unlimited product and service listings
  Upload images and videos for each item
  Manage pricing, availability, and descriptions
  Organize products with categories
  Track what's selling and what's not

✓ SECURE ESCROW SYSTEM
  Protected buyer-seller transactions
  Built-in dispute resolution
  Secure payment processing
  Transaction history and verification
  Trust-based commerce

✓ TICKET & SUPPORT MANAGEMENT
  Create and manage support tickets
  Accept public submissions
  Track ticket status and assignments
  Priority handling for urgent issues
  Complete ticket history

✓ SHOPPING CART & CHECKOUT
  Integrated e-commerce functionality
  Multiple payment gateway support (Paystack, etc.)
  Cart management and order tracking
  Abandoned cart recovery
  Sales analytics

✓ PROFESSIONAL NOTEPAD
  Create and organize business notes
  Share notes with team members
  Password-protected sensitive notes
  Schedule reminders and notifications
  Color-coded organization system

✓ TEAM & ADMIN MANAGEMENT
  User administration and role-based access
  Team collaboration tools
  Permission management
  Activity logging and audit trails

✓ REVIEWS & RATINGS SYSTEM
  Collect customer feedback
  Display ratings and reviews
  Build trust with social proof
  Manage your reputation online

✓ REAL-TIME NOTIFICATIONS
  Instant email and in-app alerts
  Custom notification preferences
  Order updates and reminders
  Never miss important events

✓ ADVERTISING & MARKETING
  Create promotional campaigns
  Target your audience effectively
  Track campaign performance
  Boost visibility for products/services

HOW TO USE THE APP

1. REGISTER & SETUP
   - Create your account
   - Verify your email
   - Complete your profile
   - Set business details

2. BUILD YOUR ONLINE PRESENCE
   - Access the Website Builder
   - Choose and customize sections
   - Add your products/services
   - Upload your logo and branding
   - Configure a custom domain

3. MANAGE YOUR BUSINESS
   - Create invoices for clients
   - Add products to your catalog
   - Process orders and payments
   - Track all transactions
   - View analytics and reports

4. ENGAGE WITH CUSTOMERS
   - Display customer reviews
   - Respond to support tickets
   - Send professional invoices
   - Manage contact requests
   - Build customer relationships

5. SCALE & GROW
   - Monitor performance metrics
   - Expand product catalog
   - Add team members
   - Streamline operations
   - Increase revenue

KEY BENEFITS

✓ All-in-One Solution - No need for multiple tools
✓ Professional Appearance - Impress your customers
✓ Time Savings - Automate repetitive tasks
✓ Secure Transactions - Bank-level security
✓ Easy to Use - Intuitive interface, no coding needed
✓ Scalable - Grows with your business
✓ Affordable - Cost-effective for all sizes
✓ Support - Comprehensive help and documentation

PERFECT FOR

• Freelancers & Consultants
• E-commerce Sellers
• Service Providers
• Small & Medium Businesses
• Content Creators
• Product Resellers
• Digital Agencies
• Entrepreneurs & Startups

Start building your business today! Sign up now and get your professional online presence up and running in minutes.`}
  />
)}

{showFeaturesModal && (
  <Modal
    title="Features"
    onClose={() => setShowFeaturesModal(false)}
    content={`MARKETBOOK SOLUTION - COMPREHENSIVE FEATURES

📄 PROFESSIONAL INVOICING
- Generate professional invoices
- Support multiple currencies
- Invoice status tracking
- Email delivery
- PDF export

📦 ITEM MANAGEMENT
- Create product listings
- Add descriptions and pricing
- Organize with categories
- Track inventory
- Manage availability

🔐 SECURE ESCROW SYSTEM
- Protected transactions
- Buyer/seller protection
- Dispute resolution
- Secure payments
- Transaction history

🎫 TICKET MANAGEMENT
- Create and track tickets
- Public submissions
- Assign to teams
- Priority handling
- Status monitoring

🔔 SMART NOTIFICATIONS
- Real-time notifications
- Email notifications
- Customizable preferences
- Multi-channel delivery

📝 ADVANCED NOTEPAD
- Create and organize notes
- Schedule with reminders
- Email reminders
- Share with users
- Color-coded organization

📢 ADVERTISEMENT MANAGEMENT
- Create and publish ads
- Targeted campaigns
- Performance tracking
- Banner system
- Scheduling

⚙️ ADMIN CONTROL PANEL
- User administration
- Role-based access
- Global oversight
- System configuration
- Audit trails

🌐 WEBSITE CREATION
- Build fully customizable websites
- Drag-and-drop page editor
- Pre-designed templates
- Mobile-friendly/responsive design
- Custom domains and hosting
- SEO optimization
- Blog and content management
- E-commerce integration
- Analytics and performance tracking
- Easy updates and maintenance


WHO CAN BENEFIT?

🏪 Sellers - Manage inventory, create invoices
🏢 Businesses & Organizations - Small businesses, large companies, schools, and organizations managing operations securely
🛠️ Admins - Oversee activities, manage users`}

  />
)}

{showContactModal && (
  <Modal
    title="Contact Us"
    onClose={() => setShowContactModal(false)}
    content={`We’d love to hear from you! Whether you have questions, need support, or want to share feedback, our team is here to help.

How to Reach Us

Customer Support
For assistance with your account, invoices, created websites, or any technical issues, please reach out to us through our Support Ticket system. You can also contact us via email.
If you’re interested in upgrading your plan, please contact Customer Service to get Premium access. Premium access includes User Admin functionality, allowing you to create websites and access advanced tools for managing and optimizing your business operations.

📧 support@marketbooksolution.com
📞 +234-707-101-6230

We aim to respond to all inquiries within 24–48 hours. Thank you for choosing Marketbooksolution!`}

  />
)}

{showPrivacyPolicyModal && (
  <Modal
    title="Privacy Policy"
    onClose={() => setShowPrivacyPolicyModal(false)}
    content={`We are committed to protecting your personal information and your right to privacy. When you use Marketbooksolution, we may collect necessary data to deliver and improve our services.

Your data is:
• Never sold to third parties
• Secured using industry-standard encryption
• Used only to provide and enhance your experience

You have the right to access, update, or delete your information at any time. For full privacy details or inquiries, please contact us at: support@marketbooksolution.com`}

  />
)}
    </div>
  )
}









// import { useState, useEffect } from 'react'
// import { Link } from 'react-router-dom'
// import axios from 'axios'
// import {
//   FiChevronLeft,
//   FiChevronRight,
//   FiShield,
//   FiMail,
//   FiPhone,
//   FiMapPin,
//   FiX
// } from 'react-icons/fi'
// import AdUnit from '../common/AdUnit'

// export default function AuthLayout({ children }) {
//   const [advertisements, setAdvertisements] = useState([])
//   const [currentAdIndex, setCurrentAdIndex] = useState(0)
//   const [loading, setLoading] = useState(true)
//   const [showAboutModal, setShowAboutModal] = useState(false)
//   const [showFeaturesModal, setShowFeaturesModal] = useState(false)
//   const [showContactModal, setShowContactModal] = useState(false)
//     const [showPrivacyPolicyModal, setShowPrivacyPolicyModal] = useState(false) // 🔧 Added


//   useEffect(() => {
//     fetchAdvertisements()
//   }, [])

//   useEffect(() => {
//     if (advertisements.length > 1) {
//       const interval = setInterval(() => {
//         setCurrentAdIndex((prev) => (prev + 1) % advertisements.length)
//       }, 5000)
//       return () => clearInterval(interval)
//     }
//   }, [advertisements.length])

//   const fetchAdvertisements = async () => {
//     try {
//       const response = await axios.get('/advertisements/active')
//       setAdvertisements(response.data.advertisements || [])
//     } catch (error) {
//       console.error('Error fetching advertisements:', error)
//       setAdvertisements([])
//     } finally {
//       setLoading(false)
//     }
//   }

//   const nextAd = () => {
//     setCurrentAdIndex((prev) => (prev + 1) % advertisements.length)
//   }

//   const prevAd = () => {
//     setCurrentAdIndex((prev) => (prev - 1 + advertisements.length) % advertisements.length)
//   }

//   const Modal = ({ title, content, onClose }) => (
//     <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4">
//       <div className="bg-white max-w-2xl w-full rounded-lg shadow-lg overflow-y-auto max-h-[90vh] relative p-6">
//         <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700">
//           <FiX className="w-5 h-5" />
//         </button>
//         <h2 className="text-2xl font-bold mb-4">{title}</h2>
//         <div className="text-gray-700 whitespace-pre-wrap text-sm leading-relaxed">{content}</div>
//       </div>
//     </div>
//   )

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-primary-50 via-blue-50 to-indigo-100">
//       {/* Header */}
//       <header className="bg-white shadow-sm border-b border-gray-200">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex items-center justify-between h-16">
//             <div className="flex items-center">
//               <div className="flex-shrink-0 flex items-center">
//                 <div className="w-10 h-10 bg-gradient-to-br from-primary-600 to-primary-700 rounded-lg flex items-center justify-center mr-3">
//                   <FiShield className="w-6 h-6 text-white" />
//                 </div>
//                 <div>
//                   <h1 className="text-xl font-bold text-gray-900">
//                     Marketbook<span className="text-primary-600">&solution</span>
//                   </h1>
//                   <p className="text-xs text-gray-500">Professional invoicing and business management</p>
//                 </div>
//               </div>
//             </div>
//             <nav className="hidden md:flex items-center space-x-8">
//               <button onClick={() => setShowFeaturesModal(true)} className="text-gray-600 hover:text-primary-600 text-sm font-medium transition-colors">Features</button>
//               <button onClick={() => setShowAboutModal(true)} className="text-gray-600 hover:text-primary-600 text-sm font-medium transition-colors">About</button>
//               <button onClick={() => setShowContactModal(true)} className="text-gray-600 hover:text-primary-600 text-sm font-medium transition-colors">Contact</button>
//                 <button onClick={() => setShowPrivacyPolicyModal(true)}  className="text-gray-600 hover:text-primary-600 text-sm font-medium transition-colors">PrivacyPolicy</button>
//               {/* <Link to="/global-admin-login" className="text-gray-600 hover:text-primary-600 text-sm font-medium transition-colors">Admin Portal</Link> */}
//             </nav>
//             <div className="hidden lg:flex items-center space-x-4 text-sm text-gray-600">
//               <div className="flex items-center">
//                 <FiMail className="w-4 h-4 mr-1" />
//                 <span>support@marketbooksolution.com</span>
//               </div>
//               <div className="flex items-center">
//                 {/* <FiPhone className="w-4 h-4 mr-1" /> */}
//               </div>
//             </div>
//           </div>
//         </div>
//       </header>

//       {/* Existing JSX */}
//     <div className="flex min-h-[calc(100vh-64px)]">
//         {/* Left Side */}
//         <div className="hidden lg:flex lg:w-1/2 items-center justify-center p-12 bg-gradient-to-br from-primary-600 to-primary-800">
//           <div className="max-w-md text-center text-white">
//             <div className="mb-8">
//               <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
//                 <FiShield className="w-10 h-10 text-white" />
//               </div>
//               <h1 className="text-4xl font-bold mb-4">
//                 Welcome to Marketbook<span className="text-primary-200">&solution</span>
//               </h1>
//               <p className="text-xl text-primary-100 mb-8">
//                 The complete Professional management system
//               </p>
//             </div>
//             <div className="space-y-6 text-left">
//               {/* Feature Items */}
//               <div className="flex items-start space-x-4">
//                 <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center mt-1">
//                   <div className="w-2 h-2 bg-white rounded-full"></div>
//                 </div>
//                 <div>
//                   <h3 className="font-semibold text-white mb-1">Professional Invoice Generation</h3>
//                   <p className="text-primary-100 text-sm">Create, send, and track professional invoices and notes with ease</p>
//                 </div>
//               </div>
//               <div className="flex items-start space-x-4">
//                 <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center mt-1">
//                   <div className="w-2 h-2 bg-white rounded-full"></div>
//                 </div>
//                 <div>
//                   <h3 className="font-semibold text-white mb-1">Advanced Admin Controls</h3>
//                   <p className="text-primary-100 text-sm">Comprehensive management tools for power users</p>
//                 </div>
//               </div>
//               <div className="flex items-start space-x-4">
//                 <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center mt-1">
//                   <div className="w-2 h-2 bg-white rounded-full"></div>
//                 </div>
//                 <div>
//                   <h3 className="font-semibold text-white mb-1">Real-time Notifications & Escrow Support</h3>
//                   <p className="text-primary-100 text-sm">Stay updated with instant alerts and ensure secure transactions through built-in escrow features.</p>
//                 </div>
//               </div>
//               <div className="flex items-start space-x-4">
//                 <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center mt-1">
//                   <div className="w-2 h-2 bg-white rounded-full"></div>
//                 </div>
//                 <div>
//                   <h3 className="font-semibold text-white mb-1">24/7 Support System & Professional Services</h3>
//                   <p className="text-primary-100 text-sm">Get help when you need it with our dedicated supports, and we also offer custom website development, product designs, and logo creation to elevate your business.</p>
//                 </div>
//               </div>
//             </div>
//             <div className="mt-8 pt-8 border-t border-white/20">
//               <p className="text-primary-100 text-sm">Trusted by thousands of businesses worldwide</p>
//             </div>
//           </div>
//         </div>

//         {/* Right Side */}
//         <div className="w-full lg:w-1/2 flex flex-col">
//           {!loading && advertisements.length > 0 && (
//             <div className="bg-white shadow-sm border-b border-gray-200">
//               <div className="relative h-32 md:h-40 overflow-hidden">
//                 {advertisements.map((ad, index) => (
//                   <div
//                     key={ad._id}
//                     className={`absolute inset-0 transition-transform duration-500 ease-in-out ${
//                       index === currentAdIndex ? 'translate-x-0' : index < currentAdIndex ? '-translate-x-full' : 'translate-x-full'
//                     }`}
//                   >
//                     <div className="flex items-center justify-center h-full px-6 bg-gradient-to-r from-gray-50 to-white">
//                       {ad.mediaType === 'image' ? (
//                         <img src={ad.mediaUrl} alt={ad.name} className="max-h-full max-w-[200px] object-contain rounded-lg shadow-sm"
//                           onError={(e) => { e.target.style.display = 'none' }} />
//                       ) : (
//                         <video src={ad.mediaUrl} autoPlay muted loop className="max-h-full max-w-[200px] object-contain rounded-lg shadow-sm"
//                           onError={(e) => { e.target.style.display = 'none' }} />
//                       )}
//                       <div className="ml-6 flex-1 max-w-md">
//                         <h3 className="text-lg font-semibold text-gray-900 mb-1">{ad.name}</h3>
//                         <p className="text-sm text-gray-600">{ad.description}</p>
//                         <div className="mt-2">
//                           <span className="inline-block px-2 py-1 bg-primary-100 text-primary-800 text-xs font-medium rounded-full">
//                             Featured
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//                 {advertisements.length > 1 && (
//                   <>
//                     <button onClick={prevAd} className="absolute left-2 top-1/2 -translate-y-1/2 p-2 rounded-full bg-white/90 hover:bg-white shadow-md transition-all hover:scale-105">
//                       <FiChevronLeft className="w-5 h-5 text-gray-600" />
//                     </button>
//                     <button onClick={nextAd} className="absolute right-2 top-1/2 -translate-y-1/2 p-2 rounded-full bg-white/90 hover:bg-white shadow-md transition-all hover:scale-105">
//                       <FiChevronRight className="w-5 h-5 text-gray-600" />
//                     </button>
//                   </>
//                 )}
//               </div>
//               {advertisements.length > 1 && (
//                 <div className="flex justify-center py-3 space-x-2 bg-gray-50">
//                   {advertisements.map((_, index) => (
//                     <button
//                       key={index}
//                       onClick={() => setCurrentAdIndex(index)}
//                       className={`w-2 h-2 rounded-full transition-all ${
//                         index === currentAdIndex ? 'bg-primary-600 w-6' : 'bg-gray-300 hover:bg-gray-400'
//                       }`}
//                     />
//                   ))}
//                 </div>
//               )}
//             </div>
//           )}

//           {/* Auth Form Container */}
//           <div className="flex-1 flex items-center justify-center p-6 bg-white">
//             <div className="w-full max-w-md">
//               <div className="lg:hidden text-center mb-8">
//                 <div className="w-16 h-16 bg-gradient-to-br from-primary-600 to-primary-700 rounded-xl flex items-center justify-center mx-auto mb-4">
//                   <FiShield className="w-8 h-8 text-white" />
//                 </div>
//                 <h1 className="text-3xl font-bold text-gray-900 mb-2">
//                   Marketbook<span className="text-primary-600">&solution</span>
//                 </h1>
//                 <p className="text-gray-600">Professional business management</p>
//               </div>
//               {children}
//               <AdUnit />
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Footer */}
//       <footer className="bg-gray-900 text-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
//           <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
//             <div className="col-span-1 md:col-span-2">
//               <div className="flex items-center mb-4">
//                 <div className="w-10 h-10 bg-gradient-to-br from-primary-600 to-primary-700 rounded-lg flex items-center justify-center mr-3">
//                   <FiShield className="w-6 h-6 text-white" />
//                 </div>
//                 <div>
//                   <h3 className="text-xl font-bold">
//                     Marketbook<span className="text-primary-400">&solution</span>
//                   </h3>
//                   <p className="text-gray-400 text-sm">Professional invoicing and business management</p>
//                 </div>
//               </div>
//               <p className="text-gray-300 mb-4 max-w-md">
//                 Empowering businesses with Professional invoicing and business management tools.
//                 Create, manage, and grow your business with our comprehensive platform.
//               </p>
//               <div className="space-y-2">
//                 <div className="flex items-center text-gray-300">
//                   <FiMail className="w-4 h-4 mr-2" />
//                   <span className="text-sm">support@marketbooksolution.com</span>
//                 </div>
//               </div>
//             </div>

//             <div>
//               <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
//               <ul className="space-y-2">
//                 <li><button onClick={() => setShowFeaturesModal(true)} className="text-gray-300 hover:text-white transition-colors text-sm">Features</button></li>
//                  <li><button onClick={() => setShowPrivacyPolicyModal(true)} className="text-gray-300 hover:text-white transition-colors text-sm">Privacy Policy</button></li>
//                 <li><button onClick={() => setShowAboutModal(true)} className="text-gray-300 hover:text-white transition-colors text-sm">About Us</button></li>
//                 <li><button onClick={() => setShowContactModal(true)} className="text-gray-300 hover:text-white transition-colors text-sm">Contact</button></li>
//                 {/* <li><Link to="/global-admin-login" className="text-gray-300 hover:text-white transition-colors text-sm">Admin Portal</Link></li> */}
//               </ul>
//             </div>

//             <div>
//               <h3 className="font-semibold mb-2 text-white">About Us</h3>
//               <p className="text-gray-400 leading-relaxed">
//                 MarketbookSolution is designed to help your business stand out and operate more efficiently.
//                 With our platform, customers can easily find you, and you can manage your business like a pro.
//                 Send professional invoices & notes, track payments, monitor pending or unpaid items, and stay on top
//                 of your sales—all in one place.
//               </p>
//             </div>
//           </div>

//           <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
//             <p className="text-gray-400 text-sm">© 2024 Marketbook&solution. All rights reserved.</p>
//           </div>
//         </div>
//       </footer>

// {/* MODALS */}
// {showAboutModal && (
//   <Modal
//     title="About Marketbooksolution"
//     onClose={() => setShowAboutModal(false)}
//     content={`ABOUT MARKETBOOK SOLUTION

// Marketbook Solution is a comprehensive professional invoicing and business management platform designed to empower businesses of all sizes.

// KEY FEATURES

//  Professional Invoicing - Generate invoices, support multiple currencies, track status
//  Item Management - Create listings, track inventory, manage availability
//  Secure Escrow - Protected transactions, buyer/seller protection, dispute resolution
//  Ticket Management - Track tickets, assign to teams, priority handling
//  Notifications - Real-time alerts, email notifications, customizable preferences
//  Notepad - Create notes, schedule reminders, share with users, color-coded
//  Advertisements - Create ads, targeted campaigns, performance tracking
//  Admin Panel - User administration, role-based access, system configuration

// WHY CHOOSE US?

//  All-in-One Platform
//  Secure Transactions
//  Professional Tools
//  Real-Time Notifications
//  User-Friendly Interface
//  Scalable Solution`}
//   />
// )}

// {showFeaturesModal && (
//   <Modal
//     title="Features"
//     onClose={() => setShowFeaturesModal(false)}
//     content={`MARKETBOOK SOLUTION - COMPREHENSIVE FEATURES

// 📄 PROFESSIONAL INVOICING
// - Generate professional invoices
// - Support multiple currencies
// - Invoice status tracking
// - Email delivery
// - PDF export

// 📦 ITEM MANAGEMENT
// - Create product listings
// - Add descriptions and pricing
// - Organize with categories
// - Track inventory
// - Manage availability

// 🔐 SECURE ESCROW SYSTEM
// - Protected transactions
// - Buyer/seller protection
// - Dispute resolution
// - Secure payments
// - Transaction history

// 🎫 TICKET MANAGEMENT
// - Create and track tickets
// - Public submissions
// - Assign to teams
// - Priority handling
// - Status monitoring

// 🔔 SMART NOTIFICATIONS
// - Real-time notifications
// - Email notifications
// - Customizable preferences
// - Multi-channel delivery

// 📝 ADVANCED NOTEPAD
// - Create and organize notes
// - Schedule with reminders
// - Email reminders
// - Share with users
// - Color-coded organization

// 📢 ADVERTISEMENT MANAGEMENT
// - Create and publish ads
// - Targeted campaigns
// - Performance tracking
// - Banner system
// - Scheduling

// ⚙️ ADMIN CONTROL PANEL
// - User administration
// - Role-based access
// - Global oversight
// - System configuration
// - Audit trails

// WHO CAN BENEFIT?

// 🏪 Sellers - Manage inventory, create invoices
// 🏢 Businesses & Organizations - Small businesses, large companies, schools, and organizations managing operations securely
// 🛠️ Admins - Oversee activities, manage users`}

//   />
// )}

// {showContactModal && (
//   <Modal
//     title="Contact Us"
//     onClose={() => setShowContactModal(false)}
//     content={`We’d love to hear from you! Whether you have questions, need support, or want to share feedback, our team is here to help.

// How to Reach Us

// Customer Support
// For assistance with your account, invoices, or technical issues, please reach out to us through our Support ticket and also you can email us:

// 📧 support@marketbooksolution.com

// We aim to respond to all inquiries within 24–48 hours. Thank you for choosing Marketbooksolution!`}

//   />
// )}

// {showPrivacyPolicyModal && (
//   <Modal
//     title="Privacy Policy"
//     onClose={() => setShowPrivacyPolicyModal(false)}
//     content={`We are committed to protecting your personal information and your right to privacy. When you use Marketbooksolution, we may collect necessary data to deliver and improve our services.

// Your data is:
// • Never sold to third parties
// • Secured using industry-standard encryption
// • Used only to provide and enhance your experience

// You have the right to access, update, or delete your information at any time. For full privacy details or inquiries, please contact us at: support@marketbooksolution.com`}

//   />
// )}
//     </div>
//   )
// }











// import { useState, useEffect } from 'react'
// import { Link } from 'react-router-dom'
// import axios from 'axios'
// import { FiChevronLeft, FiChevronRight, FiShield, FiMail, FiPhone, FiMapPin } from 'react-icons/fi'

// export default function AuthLayout({ children }) {
//   const [advertisements, setAdvertisements] = useState([])
//   const [currentAdIndex, setCurrentAdIndex] = useState(0)
//   const [loading, setLoading] = useState(true)

//   useEffect(() => {
//     fetchAdvertisements()
//   }, [])

//   useEffect(() => {
//     if (advertisements.length > 1) {
//       const interval = setInterval(() => {
//         setCurrentAdIndex((prev) => (prev + 1) % advertisements.length)
//       }, 5000)
//       return () => clearInterval(interval)
//     }
//   }, [advertisements.length])

//   const fetchAdvertisements = async () => {
//     try {
//       const response = await axios.get('/advertisements/active')
//       setAdvertisements(response.data.advertisements || [])
//     } catch (error) {
//       console.error('Error fetching advertisements:', error)
//       setAdvertisements([])
//     } finally {
//       setLoading(false)
//     }
//   }

//   const nextAd = () => {
//     setCurrentAdIndex((prev) => (prev + 1) % advertisements.length)
//   }

//   const prevAd = () => {
//     setCurrentAdIndex((prev) => (prev - 1 + advertisements.length) % advertisements.length)
//   }

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-primary-50 via-blue-50 to-indigo-100">
//       {/* Professional Header */}
//       <header className="bg-white shadow-sm border-b border-gray-200">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex items-center justify-between h-16">
//             <div className="flex items-center">
//               <div className="flex-shrink-0 flex items-center">
//                 <div className="w-10 h-10 bg-gradient-to-br from-primary-600 to-primary-700 rounded-lg flex items-center justify-center mr-3">
//                   <FiShield className="w-6 h-6 text-white" />
//                 </div>
//                 <div>
//                   <h1 className="text-xl font-bold text-gray-900">
//                     Marketbook<span className="text-primary-600">&solution</span>
//                   </h1>
//                   <p className="text-xs text-gray-500">Professional Marketplace</p>
//                 </div>
//               </div>
//             </div>
//             <nav className="hidden md:flex items-center space-x-8">
//               <a href="#features" className="text-gray-600 hover:text-primary-600 text-sm font-medium transition-colors">Features</a>
//               <a href="#about" className="text-gray-600 hover:text-primary-600 text-sm font-medium transition-colors">About</a>
//               <a href="#contact" className="text-gray-600 hover:text-primary-600 text-sm font-medium transition-colors">Contact</a>
//               <Link to="/global-admin-login" className="text-gray-600 hover:text-primary-600 text-sm font-medium transition-colors">Admin Portal</Link>
//             </nav>
//             <div className="hidden lg:flex items-center space-x-4 text-sm text-gray-600">
//               <div className="flex items-center">
//                 <FiMail className="w-4 h-4 mr-1" />
//                 <span>support@marketbooksolution.com</span>
//               </div>
//               <div className="flex items-center">
//                 <FiPhone className="w-4 h-4 mr-1" />
//               </div>
//             </div>
//           </div>
//         </div>
//       </header>

//       <div className="flex min-h-[calc(100vh-64px)]">
//         {/* Left Side */}
//         <div className="hidden lg:flex lg:w-1/2 items-center justify-center p-12 bg-gradient-to-br from-primary-600 to-primary-800">
//           <div className="max-w-md text-center text-white">
//             <div className="mb-8">
//               <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
//                 <FiShield className="w-10 h-10 text-white" />
//               </div>
//               <h1 className="text-4xl font-bold mb-4">
//                 Welcome to Marketbook<span className="text-primary-200">&solution</span>
//               </h1>
//               <p className="text-xl text-primary-100 mb-8">
//                 The complete professional marketplace management system
//               </p>
//             </div>
//             <div className="space-y-6 text-left">
//               {/* Feature Items */}
//               <div className="flex items-start space-x-4">
//                 <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center mt-1">
//                   <div className="w-2 h-2 bg-white rounded-full"></div>
//                 </div>
//                 <div>
//                   <h3 className="font-semibold text-white mb-1">Professional Invoice Generation</h3>
//                   <p className="text-primary-100 text-sm">Create, send, and track professional invoices with ease</p>
//                 </div>
//               </div>
//               <div className="flex items-start space-x-4">
//                 <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center mt-1">
//                   <div className="w-2 h-2 bg-white rounded-full"></div>
//                 </div>
//                 <div>
//                   <h3 className="font-semibold text-white mb-1">Advanced Admin Controls</h3>
//                   <p className="text-primary-100 text-sm">Comprehensive management tools for power users</p>
//                 </div>
//               </div>
//               <div className="flex items-start space-x-4">
//                 <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center mt-1">
//                   <div className="w-2 h-2 bg-white rounded-full"></div>
//                 </div>
//                 <div>
//                   <h3 className="font-semibold text-white mb-1">Real-time Notifications & Escrow Support</h3>
//                   <p className="text-primary-100 text-sm">Stay updated with instant alerts and ensure secure transactions through built-in escrow features.</p>
//                 </div>
//               </div>
//               <div className="flex items-start space-x-4">
//                 <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center mt-1">
//                   <div className="w-2 h-2 bg-white rounded-full"></div>
//                 </div>
//                 <div>
//                   <h3 className="font-semibold text-white mb-1">24/7 Support System & Professional Services</h3>
//                   <p className="text-primary-100 text-sm">Get help when you need it with our dedicated support, and we also offer custom website development, product designs, and logo creation to elevate your business.</p>
//                 </div>
//               </div>
//             </div>
//             <div className="mt-8 pt-8 border-t border-white/20">
//               <p className="text-primary-100 text-sm">Trusted by thousands of businesses worldwide</p>
//             </div>
//           </div>
//         </div>

//         {/* Right Side */}
//         <div className="w-full lg:w-1/2 flex flex-col">
//           {!loading && advertisements.length > 0 && (
//             <div className="bg-white shadow-sm border-b border-gray-200">
//               <div className="relative h-32 md:h-40 overflow-hidden">
//                 {advertisements.map((ad, index) => (
//                   <div
//                     key={ad._id}
//                     className={`absolute inset-0 transition-transform duration-500 ease-in-out ${
//                       index === currentAdIndex ? 'translate-x-0' : index < currentAdIndex ? '-translate-x-full' : 'translate-x-full'
//                     }`}
//                   >
//                     <div className="flex items-center justify-center h-full px-6 bg-gradient-to-r from-gray-50 to-white">
//                       {ad.mediaType === 'image' ? (
//                         <img src={ad.mediaUrl} alt={ad.name} className="max-h-full max-w-[200px] object-contain rounded-lg shadow-sm"
//                           onError={(e) => { e.target.style.display = 'none' }} />
//                       ) : (
//                         <video src={ad.mediaUrl} autoPlay muted loop className="max-h-full max-w-[200px] object-contain rounded-lg shadow-sm"
//                           onError={(e) => { e.target.style.display = 'none' }} />
//                       )}
//                       <div className="ml-6 flex-1 max-w-md">
//                         <h3 className="text-lg font-semibold text-gray-900 mb-1">{ad.name}</h3>
//                         <p className="text-sm text-gray-600">{ad.description}</p>
//                         <div className="mt-2">
//                           <span className="inline-block px-2 py-1 bg-primary-100 text-primary-800 text-xs font-medium rounded-full">
//                             Featured
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//                 {advertisements.length > 1 && (
//                   <>
//                     <button onClick={prevAd} className="absolute left-2 top-1/2 -translate-y-1/2 p-2 rounded-full bg-white/90 hover:bg-white shadow-md transition-all hover:scale-105">
//                       <FiChevronLeft className="w-5 h-5 text-gray-600" />
//                     </button>
//                     <button onClick={nextAd} className="absolute right-2 top-1/2 -translate-y-1/2 p-2 rounded-full bg-white/90 hover:bg-white shadow-md transition-all hover:scale-105">
//                       <FiChevronRight className="w-5 h-5 text-gray-600" />
//                     </button>
//                   </>
//                 )}
//               </div>
//               {advertisements.length > 1 && (
//                 <div className="flex justify-center py-3 space-x-2 bg-gray-50">
//                   {advertisements.map((_, index) => (
//                     <button
//                       key={index}
//                       onClick={() => setCurrentAdIndex(index)}
//                       className={`w-2 h-2 rounded-full transition-all ${
//                         index === currentAdIndex ? 'bg-primary-600 w-6' : 'bg-gray-300 hover:bg-gray-400'
//                       }`}
//                     />
//                   ))}
//                 </div>
//               )}
//             </div>
//           )}

//           {/* Auth Form Container */}
//           <div className="flex-1 flex items-center justify-center p-6 bg-white">
//             <div className="w-full max-w-md">
//               <div className="lg:hidden text-center mb-8">
//                 <div className="w-16 h-16 bg-gradient-to-br from-primary-600 to-primary-700 rounded-xl flex items-center justify-center mx-auto mb-4">
//                   <FiShield className="w-8 h-8 text-white" />
//                 </div>
//                 <h1 className="text-3xl font-bold text-gray-900 mb-2">
//                   Marketbook<span className="text-primary-600">&solution</span>
//                 </h1>
//                 <p className="text-gray-600">Professional marketplace management</p>
//               </div>
//               {children}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Footer */}
//       <footer className="bg-gray-900 text-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
//           <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
//             <div className="col-span-1 md:col-span-2">
//               <div className="flex items-center mb-4">
//                 <div className="w-10 h-10 bg-gradient-to-br from-primary-600 to-primary-700 rounded-lg flex items-center justify-center mr-3">
//                   <FiShield className="w-6 h-6 text-white" />
//                 </div>
//                 <div>
//                   <h3 className="text-xl font-bold">
//                     Marketbook<span className="text-primary-400">&solution</span>
//                   </h3>
//                   <p className="text-gray-400 text-sm">Professional Marketplace</p>
//                 </div>
//               </div>
//               <p className="text-gray-300 mb-4 max-w-md">
//                 Empowering businesses with professional marketplace management tools.
//                 Create, manage, and grow your business with our comprehensive platform.
//               </p>
//               <div className="space-y-2">
//                 <div className="flex items-center text-gray-300">
//                   <FiMail className="w-4 h-4 mr-2" />
//                   <span className="text-sm">support@marketbooksolution.com</span>
//                 </div>
//               </div>
//             </div>

//             <div>
//               <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
//               <ul className="space-y-2">
//                 <li><a href="#features" className="text-gray-300 hover:text-white transition-colors text-sm">Features</a></li>
//                 <li><a href="#pricing" className="text-gray-300 hover:text-white transition-colors text-sm">Pricing</a></li>
//                 <li><a href="#about" className="text-gray-300 hover:text-white transition-colors text-sm">About Us</a></li>
//                 <li><a href="#contact" className="text-gray-300 hover:text-white transition-colors text-sm">Contact</a></li>
//                 <li><Link to="/global-admin-login" className="text-gray-300 hover:text-white transition-colors text-sm">Admin Portal</Link></li>
//               </ul>
//             </div>

//             {/* About Us Replacement */}
//             <div>
//               <h3 className="font-semibold mb-2 text-white">About Us</h3>
//               <p className="text-gray-400 leading-relaxed">
//                 MarketbookSolution is designed to help your business stand out and operate more efficiently.
//                 With our platform, customers can easily find you, and you can manage your business like a pro.
//                 Send professional invoices, track payments, monitor pending or unpaid items, and stay on top
//                 of your sales—all in one place.
//               </p>
//             </div>
//           </div>

//           <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
//             <p className="text-gray-400 text-sm">© 2024 Marketbook&solution. All rights reserved.</p>
//           </div>
//         </div>
//       </footer>
//     </div>
//   )
// }



// add this without removing anything in the code and give me the update code Contact Us modal content  

// We’d love to hear from you! Whether you have questions, need support, or want to share feedback, our team is here to help.

// How to Reach Us

// Customer Support
// For assistance with your account, invoices, or technical issues, please reach out to us through our Support ticket and also you can email us :
// 📧 support@marketbooksolution.com

// We aim to respond to all inquiries within 24–48 hours. Thank you for choosing Marketbooksolution!








// Features modal content 
// Features

// Marketbooksolution offers a comprehensive set of features designed to simplify your business management and enhance your productivity. Here’s what you can expect:

// 1. Professional Invoicing

// Create, customize, and send polished invoices quickly. Keep a full history of all your invoices, making it easy to track payments and resend documents when needed.

// 2. Payment Tracking & Management

// Monitor your payments in real time. Instantly see which invoices are paid, pending, or overdue, helping you stay on top of your cash flow.

// 3. Full Administrative Control

// You maintain ultimate control with a secure admin password. Only you can edit or delete transactions, ensuring your records remain accurate and protected.

// 4. Staff User Management

// Create user accounts for your team with tailored access levels. Staff can handle routine tasks, while sensitive functions remain restricted to you.

// 5. Secure Data & Access

// All your business data—including sales, bookings, and client information—is protected from unauthorized changes and internal errors.

// 6. Customer Management

// Store and organize client contact details, invoice history, and payment status to maintain strong customer relationships.

// 7. Sales & Performance Insights

// Get clear insights into your sales trends and outstanding payments to help you make informed business decisions.

// 8. Smart Notifications & Alerts

// Receive reminders for overdue invoices, pending approvals, and important updates so you never miss a critical task.

// 9. Cloud Backup & Multi-Device Access

// Access your business data securely from any device, anytime. Your records are automatically backed up to prevent data loss.

// 10. Intuitive Dashboard

// A clean, easy-to-use dashboard lets you manage your entire business from one place, with real-time updates and quick navigation.

// ⸻

// Marketbooksolution is built to help you run your business smarter, safer, and more professionally. Experience the power of centralized management combined with robust security and user-friendly tools.





// About us modal content 

// About Marketbooksolution

// Marketbooksolution is a powerful business management app built to help entrepreneurs, freelancers, and small business owners operate with confidence and professionalism. Our goal is simple: to give you the tools you need to manage your business efficiently, protect your data, and grow with ease.

// With Marketbooksolution, your business becomes easier to find online, and your daily operations are streamlined. From sending branded invoices to tracking payments and managing pending or unpaid items, everything you need is in one place—organized, secure, and always accessible.

// Why Choose Marketbooksolution?
// 	•	Professional Invoicing
// Create and send customized invoices to your clients in seconds. Maintain a history of all your transactions and stay on top of what’s paid, pending, or overdue.
// 	•	Smart Payment Tracking
// Never miss a payment again. Our dashboard gives you a clear overview of your income, outstanding invoices, and payment history.
// 	•	Full Administrative Control
// You’re always in charge. Only you—the business owner—can edit or delete transactions using your secure admin password. Even if you assign user logins to your team, sensitive actions remain restricted to your admin access.
// 	•	Staff Access with Limitations
// Grant limited access to your staff for routine tasks, while keeping critical business functions like deleting records or altering payments under your control.
// 	•	Security & Accountability
// We prioritize your business’s security. Your sales, bookings, and financial records are protected against unauthorized changes, mistakes, or internal misuse.
// 	•	Customer & Sales Management
// Easily manage customer profiles, track sales performance, and generate insights that help you make smarter business decisions.
// 	•	Cloud Backup & Accessibility
// Your data is automatically backed up and accessible anytime, anywhere. Work securely across devices without losing valuable information.

// ⸻

// At Marketbooksolution, we believe every business—big or small—deserves professional tools that protect and empower. Our platform gives you the structure, security, and visibility you need to run your business with confidence.

// Grow smart. Stay secure. Work professionally—with Marketbooksolution.





// Once the About  in the header and footer is clicked it’s should pop out the about us modal 

// Once the Features in the header and footer is clicked  it’s should pop out the Features modal 

// Once the contact  in the header and footer is clicked it’s should pop out the contact modal 